/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { extrudeSettings } from '../../../../../utils/Functions';
import { params } from '../../../../../redux/reducers/reducer';

const SixGlassesWindow = ({ width, height, trimWidth, glassTexture }) => {
    const trimColor = useMemo(() => {

        return params.p_t_c.replace('0x', '#');
    }, [params.p_t_c])
    
    const windowWidth = width - trimWidth * 4
    const windowHeight = (height - trimWidth * 4) / 2

    const outTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2, height / 2);
        model.lineTo(width / 2, height / 2);
        model.lineTo(width / 2, -height / 2);
        model.lineTo(-width / 2, -height / 2);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        hole.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        hole.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        hole.closePath();

        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])

    const insideTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-width / 2 + trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, height / 2 - trimWidth);
        model.lineTo(width / 2 - trimWidth, -height / 2 + trimWidth);
        model.lineTo(-width / 2 + trimWidth, -height / 2 + trimWidth);
        model.closePath();

        const hole = new THREE.Path();
        hole.moveTo(-width / 2 + (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), height / 2 - (trimWidth * 2));
        hole.lineTo(width / 2 - (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.lineTo(-width / 2 + (trimWidth * 2), -height / 2 + (trimWidth * 2));
        hole.closePath();
        
        model.holes.push(hole);

        return model;
    }, [width, height, trimWidth])
    
    const windowTrimModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-windowWidth / 2, windowHeight);
        model.lineTo(windowWidth / 2, windowHeight);
        model.lineTo(windowWidth / 2, -windowHeight);
        model.lineTo(-windowWidth / 2, -windowHeight);
        model.closePath();
        
        const hole = new THREE.Path();
        hole.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight - trimWidth / 3));
        hole.lineTo((windowWidth / 2 - trimWidth), (windowHeight - trimWidth / 3));
        hole.lineTo((windowWidth / 2 - trimWidth), -(windowHeight - trimWidth / 3));
        hole.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight - trimWidth / 3));
        hole.closePath();

        model.holes.push(hole);

        return model;
    
    }, [width, height, trimWidth])

    const glassModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-(windowWidth / 2 - trimWidth), (windowHeight - trimWidth / 3));
        model.lineTo((windowWidth / 2 - trimWidth), (windowHeight - trimWidth / 3));
        model.lineTo((windowWidth / 2 - trimWidth), -(windowHeight - trimWidth / 3));
        model.lineTo(-(windowWidth / 2 - trimWidth), -(windowHeight - trimWidth / 3));
        model.closePath();

        return model
    
    }, [width, height, trimWidth])

    const railModel = useMemo(() => {
        const model = new THREE.Shape();
        model.moveTo(-trimWidth / 2, (windowHeight - trimWidth / 3));
        model.lineTo(trimWidth / 2, (windowHeight - trimWidth / 3));
        model.lineTo(trimWidth / 2, -(windowHeight - trimWidth / 3));
        model.lineTo(-trimWidth / 2, -(windowHeight - trimWidth / 3));
        model.closePath();

        return model
    
    }, [width, height, trimWidth])
    
    return (
        <>
            <mesh name='trim'>
                <extrudeGeometry args={[outTrimModel, extrudeSettings(0.3)]} />
                <meshStandardMaterial side={THREE.DoubleSide} color={trimColor} roughness={0.5} metalness={0.2} emissive={'#101010'} toneMapped={false} />
            </mesh>
            <mesh name='inside-trim'>
                <extrudeGeometry args={[insideTrimModel, extrudeSettings(0.4)]} />
                <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.2} />
            </mesh>
            
            <group name='window-model' position={[0, 0, 0.1]}>
                <mesh name='glass-trim'>
                    <extrudeGeometry args={[windowTrimModel, extrudeSettings(0.2)]} />
                    <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.3}  />
                </mesh>
                <mesh name='glass' position={[0, 0, 0.05]}>
                    <extrudeGeometry args={[glassModel, extrudeSettings(0.08)]} />
                    <meshPhongMaterial envMap={glassTexture} side={THREE.DoubleSide} reflectivity={1} />
                </mesh>
            </group>
            {new Array(3).fill('').map((_, index) => 
                <>
                    <mesh name='pattern-rail' position={[windowWidth / 6 * index, 0, 0.1]}>
                        <extrudeGeometry args={[railModel, extrudeSettings(0.2)]} />
                        <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.3}  />
                    </mesh>
                     <mesh name='pattern-rail' position={[-windowWidth / 6 * index, 0, 0.1]}>
                        <extrudeGeometry args={[railModel, extrudeSettings(0.2)]} />
                        <meshStandardMaterial color={'#ffffff'} side={THREE.DoubleSide} metalness={0.3}  />
                    </mesh>
                </>
            )}
        </>
    )
}

export default SixGlassesWindow